import { render, staticRenderFns } from "./Tw.pug?vue&type=template&id=4d252bbb&scoped=true&lang=pug&"
import script from "./Tw.vue?vue&type=script&lang=js&"
export * from "./Tw.vue?vue&type=script&lang=js&"
import style0 from "./Tw.scss?vue&type=style&index=0&id=4d252bbb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d252bbb",
  null
  
)

export default component.exports